<script lang="ts">
    export let fill: string = "--default-color";
    export let aqiValue: number = 0;
    export let radius: string = "6";
    let totalCircumference: number = 2 * Math.PI * parseInt(radius);
    
    const SEGMENT_BOUNDS = [0, 5, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, Infinity];
    let rotationDegrees = 0; // Default to 0 if there's no valid aqiValue

    if (typeof aqiValue === "number" && !isNaN(aqiValue)) {
        let segmentIndex = 0;
        for (let i = 0; i < SEGMENT_BOUNDS.length - 1; i++) {
            if (aqiValue >= SEGMENT_BOUNDS[i] && aqiValue <= SEGMENT_BOUNDS[i + 1]) {
                segmentIndex = i;
                break;
            }
        }

        // If the AQI value is greater than 300, set the segmentIndex to the last segment, otherwise increment it by 1 so that we are rounding up to the next segment
        if (aqiValue > 300) segmentIndex = SEGMENT_BOUNDS.length - 1;
        else segmentIndex++;

        const rotationPercentage = (segmentIndex / (SEGMENT_BOUNDS.length - 1)) * 100;
        rotationDegrees = (180 * rotationPercentage) / 100;
    }
  </script>
  
  <div class="svg-box">
    <svg class="svg-content" style="--rotate: {rotationDegrees}" viewBox="-8 -8 16 16">
  
      <defs>
        <clipPath id="clip-bot">
          <rect x="-50%" y="-50%" height="50%" width="100%"  />
          
        </clipPath>
      </defs>
  
      <circle class="timer-base" r={radius} clip-path="url(#clip-bot)"/>
      <g clip-path="url(#clip-bot)">
        <circle
        class="progress-bar"
        r={radius}
        style="stroke-dasharray: {totalCircumference}; stroke-dashoffset: {totalCircumference /
          2}; stroke: {fill}; rotate: {rotationDegrees}deg;"
        />
      </g>
    </svg>
  </div>
  <style>
      @keyframes animateProgress {
      0% {
        rotate: var(--rotationDegrees);
      }
      100% {
        rotate: 0;
      }
    }
    .progress-bar {
      stroke-width: 2px;
      fill: transparent;
      animation: animateProgress 1s forwards;
    }
  
    .progress-circle{
      animation: animateProgress 1s forwards;
    }
  
    .timer-base {
      stroke: rgba(145, 142, 142, 0.699);
      stroke-width: 2px;
      fill: transparent;
    }
    
  </style>
  